import { DISCOVERY_LAB_DISTRICTS } from '../DiscoveryLabConfig.js';
import {
  EvidenceLabScene,
  type EvidenceLabRouteDefinition,
} from '../minigames/evidence-lab/EvidenceLabScene.js';
import {
  PLANT_GROWTH_ASSETS,
  PLANT_GROWTH_ASSET_LIST,
  canEnterPlantGrowthHouse,
  getMissingPlantGrowthAssets,
} from './PlantGrowthAssets.js';
import { PLANT_GROWTH_INVESTIGATION } from './PlantGrowthConfig.js';
import { canEnterLifeCyclePond } from '../life-cycle-pond/LifeCycleAssets.js';

export const PLANT_GROWTH_SCENE_KEY = 'PlantGrowthHouse';

const ROUTE: EvidenceLabRouteDefinition = {
  sceneKey: PLANT_GROWTH_SCENE_KEY,
  sceneTitle: 'PLANT GROWTH HOUSE',
  district: DISCOVERY_LAB_DISTRICTS.plantGrowthHouse,
  previousScene: 'HabitatFieldCamp',
  previousLabel: 'HABITAT FIELD CAMP',
  nextDistrict: DISCOVERY_LAB_DISTRICTS.lifeCyclePond,
  nextScene: 'LifeCyclePond',
  nextLabel: 'LIFE CYCLE POND',
  nextUnavailableMessage: 'The pond path is unlocked. Life Cycle Pond is awaiting its runtime QA gate.',
  config: PLANT_GROWTH_INVESTIGATION,
  assets: {
    dormant: PLANT_GROWTH_ASSETS.dormant,
    restored: PLANT_GROWTH_ASSETS.restored,
    card: PLANT_GROWTH_ASSETS.card,
  },
  assetList: PLANT_GROWTH_ASSET_LIST,
  getMissing: getMissingPlantGrowthAssets,
  canEnter: canEnterPlantGrowthHouse,
  canEnterNext: canEnterLifeCyclePond,
};

export class PlantGrowthScene extends EvidenceLabScene {
  static readonly requiredImageKeys = PLANT_GROWTH_ASSET_LIST.map(asset => asset.key);

  constructor() {
    super(ROUTE);
  }
}
